import { bindActionCreators } from 'redux';
import { createNewMember } from '../../../redux/members/actions';

const map = (dispatch) => ({
  ...bindActionCreators(
    {
      createNewMember,
    },
    dispatch,
  ),
});

export default map;
